import styled from 'styled-components'

export const ToggleIcon = styled.svg`
  width: 100%;
  height: auto;
  -webkit-tap-highlight-color: transparent;
  transition: transform 400ms;
  user-select: none;
  margin-left: auto;
`

export const ToggleBar = styled.path`
  fill: none;
  transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-width: 4.5;
  stroke-linecap: round;

  &:nth-child(1) {
    stroke-dasharray: 40 121;
  }

  &:nth-child(3) {
    stroke-dasharray: 30 121;
  }
`

export const ToggleButton = styled.button`
  position: relative;
  display: flex;
  padding: 0;
  width: 50px;
  height: 50px;
  border: none;
  outline: none !important;
  background-color: transparent;

  ${({ opened }) =>
    opened &&
    `
      ${ToggleIcon} {
        transform: rotate(45deg);
      }

      ${ToggleBar} {
        &:nth-child(1) {
          stroke-dashoffset: -68px;
        }

        &:nth-child(3) {
          stroke-dashoffset: -78px;
        }
      }
  `}
`
